import axios from 'src/api/axiosInstances/privateAxiosInstance';
import { BugsList, JiraIssue,JiraFilterList } from '../types/Bugs';

type AppSiteParams = {
  appName: string;
  siteCode: string;
};

export const getBugs = async (params: BugsList.Request): Promise<BugsList.Response> => {
  return axios.get('/qs/qatab/getbugslist', { params });
};

export const createBug = async (
  params: JiraIssue.CreateBug.Params,
  requestBody: JiraIssue.CreateBug.Request
): Promise<JiraIssue.CreateBug.Response> => {
  return axios.post(`/qs/qatab/jiraBugCreation?userEmailId=${params.userEmailId}`, requestBody);
};

export const getJiraFilterList = async (appName: string, siteCode: string): Promise<JiraFilterList> => {
  const params: AppSiteParams = { appName, siteCode };
  return axios.get('/qs/qatab/getJiraFilterList', { params });
};